import "../../css/Home.css";
import React, { Suspense } from "react";
import Navbar from "../../Component/Navbar.js";
import { useParams } from "react-router-dom";
import SEO from "../../Component/Layout.js";

// Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

// Image
import backgroundGamingCampus from "../../img/logo-gaming-campus.webp";

// Traduction
import { Loader } from "../../Component/ComponentTraduction.js";
import { withTranslation } from "react-i18next";

const IncomingT = ({ t }) => {
  const { lang = "fr" } = useParams();
  return (
    <div className="Home-header overflowHidden">
      <SEO
        lang={lang}
        path="/Incoming"
        title="Mon programme de cours - Arthur BRU"
        description="Programme de Master 2 (5ème année) d'Arthur BRU en développement jeu vidéo : création de Game Design Document, analyse et gestion de projet, et projet fil rouge d'expérience complète sous Unreal Engine en groupe de 4."
        ogDescription="Programme de Master 2 (5ème année) en développement jeu vidéo : Game Design Document, gestion de projet, et projet fil rouge sous Unreal Engine."
      />
      <Navbar />
      <div className="traitSeparator" id="blur"></div>
      <div>
        <div className="contactMeFlex">
          <h3 className="fontsBold underline" id="blur">
            <div className="width flex-end">
              <FontAwesomeIcon
                icon={faCircle}
                beatFade
                style={{ color: "#63E6BE" }}
                className="removeMargin"
              />
              <h4 className="Home">
                Mes projets d'école à venir 2026-2027 ( 5ème année - Master 2 )
              </h4>
              <FontAwesomeIcon
                icon={faCircle}
                beatFade
                style={{ color: "#63E6BE" }}
                className="removeMargin"
              />
            </div>
          </h3>
        </div>
        <div className="grid-incoming">
          <div className="marge-contact-play modernEnvelop" id="blur">
            <div className="flexIMG width">
              <img
                src={backgroundGamingCampus}
                alt="Choco Blast Menu Principal"
                className="sizeProjectIMG imgGameJam"
                loading="lazy"
              ></img>
            </div>
            <div className="overflow-y-incomming">
              <div className="btnDiscoverProject padding-1vw">
                <button className="btnStyleDiscoverProjectIncoming fontsBold width">
                  {t("Incoming.1")}
                </button>
              </div>
              <div className="btnDiscoverProject padding-1vw">
                <button className="btnStyleDiscoverProjectIncoming fontsBold width">
                  {t("Incoming.2")}
                </button>
              </div>
              <div className="btnDiscoverProject padding-1vw">
                <button className="btnStyleDiscoverProjectIncoming fontsBold width">
                  {t("Incoming.3")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TranslatedHome = withTranslation()(IncomingT);

export default function Incoming() {
  return (
    <Suspense fallback={<Loader />}>
      <TranslatedHome />
    </Suspense>
  );
}
